import { render, staticRenderFns } from "./xwsj_jq.vue?vue&type=template&id=2b1325bc&scoped=true&"
import script from "./xwsj_jq.vue?vue&type=script&lang=js&"
export * from "./xwsj_jq.vue?vue&type=script&lang=js&"
import style0 from "./xwsj_jq.vue?vue&type=style&index=0&id=2b1325bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1325bc",
  null
  
)

export default component.exports